import { TailSpin } from 'react-loader-spinner';

import * as S from './LoadingWrapper.styles';

type LoadingWrapperProps = {
  isLoading: boolean;
  children: any; // eslint-disable-line
  hasBackdrop?: boolean;
  isShowChindren?: boolean;
};

const defaultProps: Partial<LoadingWrapperProps> = {
  hasBackdrop: false,
};

export function LoadingWrapper(props: LoadingWrapperProps): React.ReactElement {
  const { isLoading, children, hasBackdrop } = { ...defaultProps, ...props };

  return (
    <div>
      {isLoading ? (
        <S.Container>
          {hasBackdrop && <S.Backdrop />}
          <TailSpin
            height="100"
            width="100"
            color="#2b5178"
            ariaLabel="loading"
            wrapperStyle={S.WrapperStyles}
          />
          {children}
        </S.Container>
      ) : (
        children
      )}
    </div>
  );
}
